<template>
  <section :class="{'shiftLightsDown' : isShifted}">
    <ul class="lightrope">
      <li v-for="(light, index) in lights" :key="index"></li>
    </ul>
  </section>
</template>

<script>
import breakpoints from '@/libs/breakpoints'
import auth from '@/mixins/auth'
import localStorage from 'store'

const cookieKey = 'cookies_banner'

export default {
  mixins: [auth],
  data: function () {
    return {
      lights: [],
      numberOfLights: 0,
      viewportWidth: 0,
      isShifted: false
    }
  },
  mounted: function () {
    this.fillLights()
    this.checkCookiesBanner()
  },
  methods: {
    fillLights: function () {
      const globeWidth = 10
      const globeSpacing = 38
      const lightWidth = globeWidth + globeSpacing

      this.viewportWidth = breakpoints.getWidth()
      this.numberOfLights = Math.round(this.viewportWidth / lightWidth)
      this.lights = Array(this.numberOfLights).fill('')
    },
    checkCookiesBanner: function () {
      if (this.isLoggedIn) {
        this.$store.dispatch('getUserSetting', 'showCookies').then((value) => {
          this.isShifted = !!value
        })
      } else {
        const show = localStorage.get(cookieKey)
        this.isShifted = show !== undefined ? show : true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  $globe-width:   10px;
  $globe-height:  25px;
  $globe-spacing: 38px;
  $globe-spread: 2.5px;
  $light-off-opacity: 0.4;
  $cookies-banner-height: 29px;

  .lightrope {
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    position: absolute;
    z-index: 20;
    margin: -15px 0 0 0;
    padding: 0;
    pointer-events: none;
    width: 100%;
    position: fixed;
    li {
      position: relative;
      animation-fill-mode: both;
      animation-iteration-count:infinite;
      list-style: none;
      margin: 0;
      padding: 0;
      display: block;
      width: $globe-width;
      height: $globe-height;
      border-radius: 50%;
      margin: calc($globe-spacing / 2);
      display: inline-block;
      background: rgba(0,247,165,1);
      box-shadow: 0px calc($globe-height / 6) $globe-width*2 $globe-spread rgba(0,247,165,1);
      animation-name: flash-1;
      animation-duration: 2s;
      &:nth-child(2n+1) {
        background: rgba(0,255,255,1);
        box-shadow: 0px calc($globe-height / 6) $globe-width*2 $globe-spread rgba(0,255,255,0.5);
        animation-name: flash-2;
        animation-duration: 0.4s;
      }
      &:nth-child(4n+2) {
        background: rgba(247,0,148,1);
        box-shadow: 0px calc($globe-height / 6) $globe-width*2 $globe-spread rgba(247,0,148,1);
        animation-name: flash-3;
        animation-duration: 1.1s;
      }
      &:nth-child(odd) {
        animation-duration: 1.8s;
      }
      &:nth-child(3n+1) {
        animation-duration: 1.4s;
      }
      &:before {
        content: "";
        position: absolute;
        background: #222;
        width: ($globe-width - 2);
        height: calc($globe-height / 3);
        border-radius: 3px;
        top: (0 - (calc($globe-height / 6)));
        left: 1px;
      }
      &:after {
        content: "";
        top: (0 - calc($globe-height / 2));
        left: $globe-width - 3;
        position: absolute;
        width: $globe-spacing + 12;
        height: (calc($globe-height / 3) * 2);
        border-bottom: solid #222 2px;
        border-radius: 50%;
      }
    }
  }
  @keyframes flash-1 {
      0%, 100% { background: rgba(0,247,165,1);
      box-shadow: 0px calc($globe-height / 6) $globe-width*2 $globe-spread rgba(0,247,165,1);}
      50% { background: rgba(0,247,165,$light-off-opacity);
      box-shadow: 0px calc($globe-height / 6) $globe-width*2 $globe-spread rgba(0,247,165,0.2);}
  }
  @keyframes flash-2 {
      0%, 100% { background: rgba(0,255,255,1);
      box-shadow: 0px calc($globe-height / 6) $globe-width*2 $globe-spread rgba(0,255,255,1);}
      50% { background: rgba(0,255,255,$light-off-opacity);
      box-shadow: 0px calc($globe-height / 6) $globe-width*2 $globe-spread rgba(0,255,255,0.2);}
  }
  @keyframes flash-3 {
      0%, 100% { background: rgba(247,0,148,1);
      box-shadow: 0px calc($globe-height / 6) $globe-width*2 $globe-spread rgba(247,0,148,1);}
      50% { background: rgba(247,0,148,$light-off-opacity);
      box-shadow: 0px calc($globe-height / 6) $globe-width*2 $globe-spread rgba(247,0,148,0.2);}
  }

  .shiftLightsDown {
    padding-top: $cookies-banner-height;
  }

  @media (prefers-reduced-motion: reduce) {
    .lightrope {
      li {
        animation: none
      }
    }
  }

</style>
